import { GetUserTripsForAdminState } from './getUserTripsForAdmin.types'

const initialState: GetUserTripsForAdminState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
